import React, { useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const weekColors = [
  '#6c757d', // Seg
  '#0dcaf0', // Ter
  '#0d6efd', // Qua
  '#6610f2', // Qui
  '#fd7e14', // Sex
  '#198754', // Sáb (O dia de ouro!)
  '#20c997'  // Dom
];

export const options = {
  scales: {
    x: {
      beginAtZero: true,
    },
    y: {
      beginAtZero: true,
    },
  },
  maintainAspectRatio: false,

  indexAxis: "x",
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: false,
      text: "Faturamento",
    },
  },
};

export default function Chart(props) {
  const labels = props.sales ? props.sales.map(det => det[2]) : [];
  const values = props.sales ? props.sales.map(det => det[1]) : [];

  const dados = {
    labels: labels, 
    datasets: [
      {
        label: 'Faturamento R$',
        data: values, 
        backgroundColor: labels.map((_, index) => weekColors[index % weekColors.length]),
        borderRadius: 8, 
        borderWidth: 0,  
        barThickness: 30, 
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, 
      },
      tooltip: {
        backgroundColor: '#1e1e1e',
        padding: 12,
        cornerRadius: 8,
        callbacks: {
          label: (context) => `Total: R$ ${context.raw.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          drawBorder: false,
          color: 'rgba(0, 0, 0, 0.05)',
        },
        ticks: {
          callback: (value) => `R$ ${value}`
        }
      },
      x: {
        grid: {
          display: false,
        }
      }
    }
  };

  return <Bar options={options} data={dados} />;
}